import z from 'zod';
import { zAlias } from '../../shared/zod.helpers';

export const OperationSchema = zAlias(
  z.object({
    id: z.string(),
    name: z.string(),
    modules: z.array(z.string()).optional()
  }),
  { _id: 'id' }
);

export type Operation = z.infer<typeof OperationSchema>;
